<template>
  <div id="dashboard">
      <h3>DashBoard</h3>

      <ul class="ul collection with-header">
        <li class="collection-header"><h4>Employees</h4></li>
        <li v-for="employee in employees" :key="employee.id" class="collection-item">
          <div class="chip">{{employee.department}}</div> {{employee.employeeId}}:{{employee.name}}
          <router-link v-if="employees" class="secondary-content" 
          v-bind:to="{name: 'View-Employee', params: {employeeId: employee.employeeId}}">
          <i class="fa fa-eye"></i>
          </router-link>
        </li>
      </ul>

      <div class="fixed-action-btn">
        <router-link to="/new" class="btn-floating btn-large red">
        <i class="fa fa-plus"></i>
        </router-link>
      </div>
  </div>
</template>

<script>
import db from './fbInit'
export default {
name: 'dashboard',
data() {
    return {
        employees: []
    }
},
created() {
  db.collection('employees').orderBy('department').get()
  .then(querySnapShot => {
    querySnapShot.forEach(doc => {
      // console.log(doc.data())
      const employeeData = {
        'id': doc.id,
        'employeeId': doc.data().employeeId,
        'name': doc.data().name,
        "department": doc.data().department,
        "position": doc.data().position
      }
      this.employees.push(employeeData)
    })
  })
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard.vue